import React from 'react'
import Navbar from './Navbar'
import Header from './Header'
import Footer from './Footer'

export default function UserDashboard() {
  return (
    <div>
        <Navbar />
        <Header/>
        <Footer/>
    </div>
  )
}
